import React from 'react';

import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import appI18n from '../../../../config/i18n';

interface Props {
  saving: boolean;
  onCancel: () => void;
  onSave: () => void;
}

/**
 * Footer reutilizable para el modo de edicion in-place de una Card de
 * seccion: botones "Cancelar" / "Guardar cambios" alineados a la derecha, al
 * final del cuerpo de la Card (ver Leads.scss, `.lead-section-edit-footer`).
 * Se muestra solo mientras la Card esta en modo edicion (editing === true).
 */
function SectionEditFooter({ saving, onCancel, onSave }: Props) {
  const { t } = useTranslation(undefined, { i18n: appI18n });

  return (
    <div className="lead-section-edit-footer">
      <Button
        size="small"
        icon={<CloseOutlined />}
        onClick={onCancel}
        disabled={saving}
      >
        {t('scenes.leads.components.detail_lead_modal.buttons.cancel')}
      </Button>
      <Button
        size="small"
        type="primary"
        icon={<CheckOutlined />}
        onClick={onSave}
        loading={saving}
      >
        {t('scenes.leads.components.detail_lead_modal.buttons.save_changes')}
      </Button>
    </div>
  );
}

export default SectionEditFooter;
